import { applyMiddleware, createStore } from 'redux';
import createSagaMiddleware from 'redux-saga';
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly';
import { routerMiddleware } from 'react-router-redux';
import logger from 'redux-logger';
import history from '../history';
import rootReducer from '../reducers';
import rootSaga from '../sagas';

const sagaMiddleware = createSagaMiddleware();
let middleware;

if (process.env.REACT_APP_ENVIRONMENT === 'development') {
  middleware = composeWithDevTools(
    applyMiddleware(routerMiddleware(history), sagaMiddleware, logger),
  );
} else {
  middleware = composeWithDevTools(applyMiddleware(routerMiddleware(history), sagaMiddleware));
}

const store = createStore(rootReducer, middleware);

sagaMiddleware.run(rootSaga);

export default store;
